import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { defineMessages, useIntl } from 'react-intl';

import { useCustomer } from '../../../../context';

// ─────────────────────────────────────────────────────────────────────────────

export const useGroupOrderJoinForm = () => {
  const { customer } = useCustomer();
  const { formatMessage } = useIntl();

  // ─── Derived ─────────────────────────────────────────────────────────

  const customerName = customer.firstName ?? '';

  const rules = useMemo(
    () => ({
      customerName: {
        required: formatMessage(messages.customerNameRequired),
        maxLength: {
          value: FIELD_MAX_LENGTH,
          message: formatMessage(messages.customerNameMaxLength, { max_length: FIELD_MAX_LENGTH }),
        },
      },
    }),
    [formatMessage],
  );

  const form = useForm<GroupOrderJoinFormData>({
    defaultValues: { customerName },
    mode: 'onChange',
  });

  // ─────────────────────────────────────────────────────────────────────

  return {
    form,
    rules,
    maxLengths: { customerName: FIELD_MAX_LENGTH },
  };
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  customerNameRequired: {
    defaultMessage: 'Name is required',
    description: 'Group Order Join | Name required error',
  },
  customerNameMaxLength: {
    defaultMessage: 'Name must be {max_length} characters or fewer',
    description: 'Group Order Join | Name max length error',
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const FIELD_MAX_LENGTH = 50;

// ─── Types ───────────────────────────────────────────────────────────────────

export type GroupOrderJoinFormData = {
  customerName: string;
};
